import { useRCAMainStyles } from "pages/Corporate/RCA/RCA.styles";
import RCAComplianceWholeMill from "./RCAComplianceWholeMill";
import RCAComplianceByResponsible from "./RCAComplianceByResponsible";
import RCAActionPlansPerRCA from "./RCAActionPlansPerRCA";
import RCAMethodologyUsedByUser from "./RCAMethodologyUsedByUser";

const RCACompliance = () => {
    const mainClasses = useRCAMainStyles();

    return (
        <>
            <div className={mainClasses.contentWrapper}>
                <RCAComplianceWholeMill />
            </div>
            <div className={mainClasses.contentWrapper}>
                <RCAComplianceByResponsible />
            </div>
            <div className={mainClasses.tablesWrapper}>
                <RCAActionPlansPerRCA />
                <RCAMethodologyUsedByUser />
            </div>
        </>
    );
};

export default RCACompliance;
